/* global slides:writable prevSlide completeSlide nextSlide jumpToId globalVar siAudio Howler Howl */

// do not use the id 'test' for a slide
$(function () {
	slides = {
		Start: {
			type: 'text',
			navElements: ['start-slide'],
			backAction: function () {}, //leave Start backAction as function to prevent IE9 errors
			onEnterAction: function () {},
			audio: {
				onEnter: 'media/audio/pacific-cycle/start-screen.mp3'
			},
			include: false
		},
		V1: {
			type: 'video',
			navElements: ['back', 'next'],
			backAction: prevSlide,
			nextAction: function () {
				completeSlide();
				nextSlide();
				// playMenuAudio();
			},
			onEnterAction: function () {},
			videoSeeking: true,
			videoLoaded: false //don't edit
		},
		menu: {
			type: 'hotspot',
			navElements: [],
			nextAction: function () {
				completeSlide();
			},
			backAction: function () {
				jumpToId('Start');
			},
			onEnterAction: function () {
				$('#menu .hotspot-button').removeClass('clicked');
				$('#si-click-icon').addClass('menu-click-position');
				if (slides[globalVar.curSlide].visited) {
					siAudio.menu.onEnter = new Howl({
						src: ['media/audio/sounds/nothing.mp3']
					});
				}
			},
			onExitAction: function () {
				$('#si-click-icon').removeClass('menu-click-position');
			},
			audio: {
				onEnter: 'media/audio/pacific-cycle/menu.mp3'
			},
			hotspot: {
				hotspotStyleClass: 'cogwheel',
				// modalStyleClass: 'i7-modals',
				onClick: function () {
					Howler.stop();
					$('#si-nav-container').addClass('feedback-open');
				},
				onModalClose: function (hotspot) {
					$('#si-nav-container').removeClass('feedback-open');
				},
				audio: {
					1: 'media/audio/pacific-cycle/handlebars-submenu.mp3',
					2: 'media/audio/pacific-cycle/front-wheel-submenu.mp3',
					3: 'media/audio/pacific-cycle/seat-submenu.mp3'
				}
			}
		},
		V2: {
			type: 'video',
			navElements: ['back'],
			backAction: function () {
				jumpToId('menu');
			},
			hotspot: {},
			nextAction: function () {
				completeSlide();
				$('#handlebars-start').removeClass('handlebars-start').addClass('handlebars-finish');
				$('#line-handlebar-start-id').hide();
				$('#line-handlebar-finish-id').show();
				$('.button1-background').hide();
				$('.button1-background-green').show();
				$('#bike-button1').addClass('white-text');
				$('.modal-close').click();
				var showBrakesCable = $('.show-brakes-cable').length;
				if (showBrakesCable >= 2) {
					$('#brakes-cable-id').show();
				}
				jumpToId('menu');
			},
			onEnterAction: function () {},
			videoSeeking: true,
			videoLoaded: false //don't edit
		},
		V3: {
			type: 'video',
			navElements: ['back'],
			backAction: function () {
				jumpToId('menu');
			},
			nextAction: function () {
				completeSlide();
				$('#handlebars-start').removeClass('handlebars-start').addClass('handlebars-finish');
				$('#line-handlebar-start-id').hide();
				$('#line-handlebar-finish-id').show();
				$('.button1-background').hide();
				$('.button1-background-green').show();
				$('#bike-button1').addClass('white-text');
				$('.modal-close').click();
				var showBrakesCable = $('.show-brakes-cable').length;
				if (showBrakesCable >= 2) {
					$('#brakes-cable-id').show();
				}
				jumpToId('menu');
			},
			onEnterAction: function () {},
			videoSeeking: true,
			videoLoaded: false //don't edit
		},
		V4: {
			type: 'video',
			navElements: ['back'],
			backAction: function () {
				jumpToId('menu');
			},
			nextAction: function () {
				completeSlide();
				$('#front-wheel-start').hide();
				$('#front-wheel-finish').show();
				$('#line-front-wheel-start-id').hide();
				$('#line-front-wheel-finish-id').show();
				$('.button2-background').hide();
				$('.button2-background-green').show();
				$('#bike-button2').addClass('white-text');
				$('.modal-close').click();
				jumpToId('menu');
			},
			onEnterAction: function () {},
			videoSeeking: true,
			videoLoaded: false //don't edit
		},
		V5: {
			type: 'video',
			navElements: ['back'],
			backAction: function () {
				jumpToId('menu');
			},
			nextAction: function () {
				completeSlide();
				$('#front-wheel-start').hide();
				$('#front-wheel-finish').show();
				$('#line-front-wheel-start-id').hide();
				$('#line-front-wheel-finish-id').show();
				$('.modal-close').trigger('click');
				$('.button2-background').hide();
				$('.button2-background-green').show();
				$('#bike-button2').addClass('white-text');
				$('.modal-close').click();
				jumpToId('menu');
			},
			onEnterAction: function () {},
			videoSeeking: true,
			videoLoaded: false //don't edit
		},
		V6: {
			type: 'video',
			navElements: ['back'],
			backAction: function () {
				jumpToId('menu');
			},
			nextAction: function () {
				completeSlide();
				$('#training-wheels-start').removeClass('training-wheels-start').addClass('training-wheels-finish');
				$('#line-training-wheels-start-id').hide();
				$('#line-training-wheels-finish-id').show();
				$('.button3-background').hide();
				$('.button3-background-green').show();
				$('#bike-button3').addClass('white-text');
				jumpToId('menu');
			},
			onEnterAction: function () {},
			videoSeeking: true,
			videoLoaded: false //don't edit
		},
		V7: {
			type: 'video',
			navElements: ['back'],
			backAction: function () {
				jumpToId('menu');
			},
			nextAction: function () {
				completeSlide();
				$('#seat-start').hide();
				$('#seat-finish').show();
				$('.modal-close').trigger('click');
				$('#line-seat-start-id').hide();
				$('#line-seat-finish-id').show();
				$('.button4-background').hide();
				$('.button4-background-green').show();
				$('#bike-button4').addClass('white-text');
				jumpToId('menu');
			},
			onEnterAction: function () {},
			videoSeeking: true,
			videoLoaded: false //don't edit
		},
		V8: {
			type: 'video',
			navElements: ['back'],
			backAction: function () {
				jumpToId('menu');
			},
			nextAction: function () {
				completeSlide();
				$('#seat-start').hide();
				$('#seat-finish').show();
				$('.modal-close').trigger('click');
				$('#line-seat-start-id').hide();
				$('#line-seat-finish-id').show();
				$('.button4-background').hide();
				$('.button4-background-green').show();
				$('#bike-button4').addClass('white-text');
				jumpToId('menu');
			},
			onEnterAction: function () {},
			videoSeeking: true,
			videoLoaded: false //don't edit
		},
		V9: {
			type: 'video',
			navElements: ['back'],
			backAction: function () {
				jumpToId('menu');
			},
			nextAction: function () {
				completeSlide();
				$('#pedals-start').removeClass('pedals-start').addClass('pedals-finish');
				$('#line-pedals-start-id').hide();
				$('#pedals-start-second-pedal').hide();
				$('#line-pedals-finish-id').show();
				$('.button5-background').hide();
				$('.button5-background-green').show();
				$('#bike-button5').addClass('white-text');
				jumpToId('menu');
			},
			onEnterAction: function () {},
			videoSeeking: true,
			videoLoaded: false //don't edit
		},
		V10: {
			type: 'video',
			navElements: ['back'],
			backAction: function () {
				jumpToId('menu');
			},
			nextAction: function () {
				completeSlide();
				$('#brakes-start').removeClass('brakes-start').addClass('brakes-finish').addClass('show-brakes-cable');
				$('#line-brakes-start-id').hide();
				$('#line-brakes-finish-id').show();
				$('.button6-background').hide();
				$('.button6-background-green').show();
				$('#bike-button6').addClass('white-text');
				var showBrakesCable = $('.show-brakes-cable').length;
				if (showBrakesCable >= 2) {
					$('#brakes-cable-id').show();
				}
				jumpToId('menu');
			},
			onEnterAction: function () {},
			videoSeeking: true,
			videoLoaded: false //don't edit
		},
		V11: {
			type: 'video',
			navElements: ['back'],
			backAction: function () {
				jumpToId('menu');
			},
			nextAction: function () {
				completeSlide();
				$('.button7-background').hide();
				$('.button7-background-green').show();
				$('#bike-button7').addClass('white-text');
				jumpToId('menu');
			},
			onEnterAction: function () {},
			videoSeeking: true,
			videoLoaded: false //don't edit
		}
	};
});
